import React, { useEffect, useContext } from 'react';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./App.css";
import Nav from "./components/molecules/Nav";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import Locations from "./pages/Locations";
// import Location from "./pages/Location";
import { AuthContextProvider } from "./contexts/auth-context";
import AuthContext from "./contexts/auth-context";
import Auth from "./pages/Auth";
import ForgotPassword from "./pages/ForgotPassword";
// import Parking from "./pages/Parking";
// import Reports from "./pages/Reports";
import Account from "./pages/Account";
import OfficeLocation from "./pages/Office/OfficeLocation";
import EventLocation from './pages/Event/EventLocation';
import EventPage from './pages/Event/EventPage';

// Global JSON parse error handler that forces logout
const originalJSONParse = JSON.parse;
JSON.parse = function(text) {
  try {
    return originalJSONParse(text);
  } catch (error) {
    console.error("JSON parse error, forcing logout:", error);
    
    // Clear all auth data from localStorage
    localStorage.clear();
    
    // Only redirect if we're not already on the auth page
    if (window.location.pathname !== "/auth") {
      window.location.href = "/auth";
    }
    
    return {};
  }
};

// Error boundary that catches errors and forces logout
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  async componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
    const { authContext, navigate } = this.props;
    if (authContext) {
      // We must await or redirecting state hangs
      await authContext.logout();
      this.setState({ hasError: false }, () => {
        navigate('/auth', { replace: true });
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return <div>Redirecting...</div>;
    }
    return this.props.children;
  }
}

function NavigationControl() {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  return (
    <ErrorBoundary authContext={authCtx} navigate={navigate}>
      <Routes>
        <Route path="/" element={<Nav />}>
          <Route path="/auth" element={<Auth />}></Route>
          <Route path="/auth/forgotPassword" element={<ForgotPassword />}></Route>
          <Route path="/locations" element={<Locations />}></Route>
          <Route path="/locations/office/:name" element={<OfficeLocation />}></Route>
          {/* <Route path="/locations/event/:name" element={<EventLocation />}></Route> */}
          <Route path="/locations/event/:name" element={<EventPage />}></Route>

          {/* <Route path="/location/:id" element={<Location />}></Route> */}
          {/* <Route path="/smallBusinessLocation/:id" element={<SmallBusinessLocation />}></Route> */}
          {/* <Route path="/export" element={<Export />}></Route> */}
          {/* <Route path="/reports" element={<Reports />}></Route> */}
          {/* <Route path="/parking" element={<Parking />}></Route> */}

          <Route path="/account" element={<Account />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <AuthContextProvider>
      <BrowserRouter>
        <NavigationControl />
      </BrowserRouter>
    </AuthContextProvider>
  );
}

export default App;